import { useFeatureFlag } from "@src/features/app/hooks/useFeatureFlag";
import { Ff } from "@src/types.generated";

export const useNewMessagingEnabled = (): boolean => {
  return useFeatureFlag(Ff.NewMessaging);
};

export default useNewMessagingEnabled;
